import React, { Component } from "react";
import { withRouter } from "react-router";

import { history } from "utils";
import { icons } from "constants/icons";
import { Button } from "antd";

class PlusButton extends Component {
  constructor(props) {
    super(props);

    this.state = { opened: false };

    const { history } = this.props;
    this.unlisten = history.listen((location, action) => {
      if (this.state.opened) this.setState({ opened: false });
    });

    this.handleToggle = this.handleToggle.bind(this);
  }

  componentWillUnmount() {
    this.unlisten();
  }

  handleToggle() {
    this.setState({ opened: !this.state.opened });
  }

  render() {
    const { opened } = this.state;

    return (
      <div className="plus-btn">
        <div className={"secondary-btn-wrap secondary-btn-wrap-1" + (opened ? " show" : " hide")}>
          <span>Tailgate</span>
          <Button
            href="#/tailgates/create"
            shape="circle"
            icon={icons.tailgate}
            className={"secondary-btn"}
          />
        </div>
        <div className={"secondary-btn-wrap secondary-btn-wrap-2" + (opened ? " show" : " hide")}>
          <span>Incident</span>
          <Button
            href="#/incidents/create"
            shape="circle"
            icon={icons.incident}
            className={"secondary-btn"}
          />
        </div>
        <div className={"secondary-btn-wrap secondary-btn-wrap-3" + (opened ? " show" : " hide")}>
          <span>Intervention SSE</span>
          <Button href="#/sse/create" shape="circle" icon={icons.sse} className={"secondary-btn"} />
        </div>
        <div className={"secondary-btn-wrap secondary-btn-wrap-4" + (opened ? " show" : " hide")}>
          <span>Non-conformité</span>
          <Button
            href="#/notes/create"
            shape="circle"
            icon={icons.note}
            className={"secondary-btn"}
          />
        </div>
        <div className={"secondary-btn-wrap secondary-btn-wrap-5" + (opened ? " show" : " hide")}>
          <span>Photo</span>
          <Button
            href="#/documents/create"
            shape="circle"
            icon={icons.photo}
            className={"secondary-btn"}
          />
        </div>
        <div className={"secondary-btn-wrap secondary-btn-wrap-6" + (opened ? " show" : " hide")}>
          <span>Messages</span>
          <Button href="#/chat" shape="circle" icon={icons.messages} className={"secondary-btn"} />
        </div>
        <div className={"secondary-btn-wrap secondary-btn-wrap-7" + (opened ? " show" : " hide")}>
          <span>Entrée dans le journal</span>
          <Button href="#/logs" shape="circle" icon={icons.logs} className={"secondary-btn"} />
        </div>
        <Button
          shape="circle"
          icon="plus"
          size="large"
          className={"main-btn" + (opened ? " close" : " open")}
          onClick={this.handleToggle}
        />
      </div>
    );
  }
}

export default withRouter(PlusButton);
